// vendor
import { create } from 'zustand';

// types
import { type UserData } from '@libs/types';

// api
import { getUserData } from '@api/account';
import { getTotalCards } from '@api/onboarding';

interface AppState {
  userData: UserData | null;
  totalCards: number | null;
  isLoading: boolean;
  loadUserData: () => Promise<void>;
  loadTotalCards: () => Promise<void>;
}

export const useAppStore = create<AppState>((set) => ({
  userData: null,
  totalCards: null,
  isLoading: false,

  loadUserData: async () => {
    set({ isLoading: true });

    try {
      const userData = await getUserData();

      set({ userData });
    } catch (error) {
      /**
       *  TODO: probably need some notification system here
       */
      console.error('Failed to fetch user data:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  loadTotalCards: async () => {
    try {
      const data = await getTotalCards();
      const totalCards = data.total_cards;

      set({ totalCards });
    } catch (err) {
      console.error('Failed to fetch total cards:', err);
    }
  },
}));
